var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine1 = function SvgLine1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 131 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.877.742s-27.41 68.069-99.301 39.017L.999 27.807",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "1 9"
  })));
};
export default SvgLine1;